module.exports = __webpack_public_path__ + "img/skills.56917b8d.svg";